import { Component, Vue } from 'vue-property-decorator';
import { User, UserId, UserRole } from '@/types/user';

@Component({})
export default class UsersService extends Vue {
  get users(): User[] {
    return this.$store.getters['users/list'];
  }

  public getUser(userId: UserId): string {
    const userObject: User | undefined = this.users.find((user: any) => user.id === userId);
    if (!userObject) { return ''; }
    return userObject.name;
  }

  get userRoles(): UserRole[] {
    return this.$store.getters['userRoles/list'];
  }

  public getRoles(userRoles: UserRole[]): string[] {
    return userRoles.map((role: UserRole) => role ? role.name : '') as string[];
  }

  public parsedRole(userRoles: UserRole[]): number[] {
    return userRoles.map((role: UserRole) => role ? role.id : '') as number[];
  }

}
